import React from 'react'
import Navbar from '../components/Navbar'
import ContactHeader from '../components/ContactHeader'
import TransportForm from '../components/TransportForm'
import Footer from '../components/Footer'
import ContactForm from '../components/ContactForm'

function Contact() {
  return (
    <div>
        <Navbar />
        <ContactHeader />
        <ContactForm />
        <Footer />
    </div>
  )
}

export default Contact